/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Container = styled.div`
  .simple-social-proof-section--content {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 30px;

    .star-picker--container {
      margin: 10px 18px 0 0;

      @media (max-width: 575px) {
        margin: 10px 0 0 0;
      }
    }

    .simple-social-proof-section--description {
      font-size: var(--font-size-16);
      line-height: 42px;
      color: ${({ theme }) => (theme === 'light' ? 'var(--white)' : 'var(--darkest)')};
      margin: 15px 0 0;
    }
  }

  .simple-social-proof-section--logo-content {
    display: flex;
    align-items: center;
    margin-top: 28px;
    max-width: 419px;

    .simple-social-proof-section--logo-item {
      margin-right: 32px;
      display: flex;

      img {
        max-width: 100%;
      }

      &:last-child {
        margin-right: 0;
      }
    }

    @media (max-width: 991px) {
      margin-top: 18px;

      .simple-social-proof-section--logo-item {
        margin-right: 20px;
      }
    }

    @media (max-width: 695px) {
      display: flex;
      align-items: center;
      margin-top: 28px;

      .simple-social-proof-section--logo-item {
        margin-right: 27px;

        &:last-child {
          margin-right: 0;
        }

        img {
          max-width: 100%;
        }
      }
    }
  }
`;
